import { CSSProperties, FC } from 'react';

import { AMPLIFY_ORANGE, getProgramColor } from 'shared/lib/utils';

import { abbreviateProgramName } from './utils';
import styles from './styles.module.scss';

interface ProgramPillOutlinedProps {
  programName: string;
  abbreviate?: boolean;
}

/**
 * Should be used for informative purposes only.
 * Is not clickable and have styles different from DomainBadge
 * to visually mark that it is not interactive.
 * */
export const ProgramPillOutlined: FC<ProgramPillOutlinedProps> = ({
  programName,
  abbreviate,
}) => {
  const programColor = getProgramColor(programName, true);
  const inlineStyles: CSSProperties = {
    borderColor: programColor ?? AMPLIFY_ORANGE,
    color: programColor ?? AMPLIFY_ORANGE,
  };

  const displayedProgramName = abbreviate
    ? abbreviateProgramName(programName)
    : programName;

  return (
    <span className={styles.root} style={inlineStyles}>
      {displayedProgramName}
    </span>
  );
};
